<script setup>
// Conhecimento por conta (Fase 6, spec §4.4): "quem pode usar" — um checkbox por assistente da conta, gravando na
// junção via API. O kit manda no visual (Checkbox + tipografia da tela); desligado para quem não é admin.
import { computed } from 'vue';
import { Checkbox } from 'dashboard/components-next/polaris/ui/checkbox';

const props = defineProps({
  polarisDocument: { type: Object, required: true },
  assistants: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['toggle']);

const allowedIds = computed(() => props.polarisDocument.assistant_ids || []);

const isAllowed = assistantId => allowedIds.value.includes(assistantId);

const onToggle = (assistantId, checked) => {
  if (props.disabled) return;
  emit('toggle', { assistantId, allowed: Boolean(checked) });
};
</script>

<template>
  <div
    class="flex flex-wrap items-center gap-x-4 gap-y-1 px-1"
    data-testid="document-assistant-access"
  >
    <span class="text-xs text-polaris-muted-foreground">
      {{ $t('POLARIS.DOCUMENTS.SHARING.LABEL') }}
    </span>
    <label
      v-for="assistant in assistants"
      :key="assistant.id"
      class="flex items-center gap-1.5 text-xs text-polaris-foreground"
      :class="{ 'cursor-not-allowed opacity-60': disabled }"
    >
      <Checkbox
        :model-value="isAllowed(assistant.id)"
        :disabled="disabled"
        @update:model-value="onToggle(assistant.id, $event)"
      />
      {{ assistant.name }}
    </label>
  </div>
</template>
